export default __webpack_public_path__ + "static/media/SFDCError.79a78d69.svg";